import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import 'tailwindcss/tailwind.css'
import './global.scss'
import '@/style/tailwind.css'

// import '@spartez/vue-atlaskit/dist/bundle.css'
import Va from 'vue-atlas'
import 'vue-atlas/dist/vue-atlas.css'
// import 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'

import VueCookie from 'vue-cookies'

import GAuth from 'vue-google-oauth2'
import { initFb } from '@/helpers/facebook'

if (process.env.VUE_APP_GOOGLE_OAUTH2_CLIENT_ID) {
  const gauthOption = {
    clientId: process.env.VUE_APP_GOOGLE_OAUTH2_CLIENT_ID,
    scope: 'profile email',
    prompt: 'select_account',
  }
  Vue.use(GAuth, gauthOption)
}

Vue.config.productionTip = false
Vue.use(Va)
Vue.use(VueCookie)

Vue.$cookies.config('30d')

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

if (process.env.VUE_APP_FB_APP_ID) {
  initFb()
}
